import type { FC } from "react";
import React, { memo } from "react";
import clsx from "clsx";
import { CarConfigLabel } from "../../../../../../utils/labelUtils";
import Price from "../../../../common/price/Price";
import styles from "./Overview.module.scss";
import type { PackType } from "../../../../../../../../../common-deprecated/types/CommonTypes";
import Text from "../../../../../../../shared-components/css-modules/toyota/atoms/Text";
import Button from "../../../../../../../shared-components/css-modules/toyota/atoms/Button";
import useAphPack from "../../../../../../hooks/useAphPack";
import { trackSummaryCardRemovePack } from "../../../../../../utils/tracking";
import { useCarConfigSelector } from "../../../../../../redux/store";
import { showAccessoriesRate } from "../../../../../../utils/financeInsuranceRate";
import Icon from "../../../../../../../shared-components/css-modules/toyota/atoms/Icon";
import a11y from "../../../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";

const Pack: FC<{ pack: PackType }> = ({ pack }) => {
    const packProps = useAphPack(pack);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);

    if (!packProps) return null;

    const { actions } = packProps;
    const { deselectPack } = actions;
    return (
        <li className={styles.listitem}>
            <div>
                <Text variant="apheleia-body" spacing="spacing-0">
                    {pack.name}
                </Text>
            </div>
            <div className={styles.listprice}>
                <Text variant="apheleia-body" spacing="spacing-0">
                    {pack.standard || pack.price.cash === 0 ? (
                        <span className={styles.included}>
                            <CarConfigLabel label="carConfigIncluded" />
                            <span className={clsx(styles["included-icon"], styles.small)}>
                                <Icon variant="check" sizing="xs" aria-hidden="true" />
                            </span>
                        </span>
                    ) : (
                        <span className={styles["listprice-price"]}>
                            +&nbsp;
                            <Price
                                price={pack.price}
                                forceCashPrice={!showAccessoriesRate(commonSettings, carConfigSettings)}
                            />
                        </span>
                    )}
                </Text>
            </div>
            {!pack.standard && (
                <div>
                    <Button
                        variant="btn-default"
                        circle
                        sizing="xs"
                        onClick={() => {
                            trackSummaryCardRemovePack();
                            deselectPack();
                        }}
                    >
                        <Icon variant="minus" sizing="xs" aria-hidden="true" />
                        <span className={a11y["sr-only"]}>
                            <CarConfigLabel label="carConfigOverviewPacksRemove" />
                        </span>
                    </Button>
                </div>
            )}
        </li>
    );
};

export default memo(Pack);
